import React, { ReactNode } from "react";

type Props = {
  company: string;
  title: string;
  payment: string;
  location: string;
  holiday: string;
  linkUrl: string;
  children: ReactNode;
};

const ResultItem: React.FC<Props> = (props) => {
  return (
    <article className="rounded-lg bg-white shadow-[2px_2px_8px_0_rgba(51,51,51,0.25)]">
      <a href={props.linkUrl} className="group block rounded-lg">
        <div className="py-5 px-4 md:px-5">
          <p className="mb-2 text-gray text-sm leading-[1.8] font-medium">
            {props.company}
          </p>
          <h3 className="mb-3 text-xl leading-normal font-bold line-clamp-3 md:mb-5 md:text-2xl md:leading-[1.4] md:line-clamp-2">
            {props.title}
          </h3>
          <ul className="mb-1 text-brown text-xs leading-none font-bold md:mb-3 [&_li]:inline-block [&_li]:py-[3px] [&_li]:px-2.5 [&_li]:border [&_li]:border-brown [&_li]:rounded-[3px] [&_li]:bg-gray-light [&_li]:mr-2 [&_li]:mb-2">
            {props.children}
          </ul>
          <ul className="grid text-sm font-medium leading-normal sp:grid-cols-1 sp:gap-y-1 md:leading-[1.7] md:grid-cols-[40%_1fr]">
            <li className="col-[1/2]">
              <div className="flex items-end">
                <span className="flex-shrink-0 flex items-center justify-center mr-2 rounded-full bg-gray-light aspect-square w-6">
                  <svg className="block aspect-square w-[14px] fill-primary">
                    <use xlinkHref="/symbol-defs.svg#icon-dollar"></use>
                  </svg>
                </span>
                <p className="flex-1 line-clamp-1">
                  月給{" "}
                  <strong className="text-secondary text-xl leading-none font-black">
                    {props.payment}
                  </strong>
                </p>
              </div>
            </li>
            <li className="md:col-[1/2]">
              <div className="flex items-start">
                <span className="flex-shrink-0 flex items-center justify-center mr-2 rounded-full bg-gray-light aspect-square w-6">
                  <svg className="block aspect-square w-[14px] fill-primary">
                    <use xlinkHref="/symbol-defs.svg#icon-pin2"></use>
                  </svg>
                </span>
                <p className="flex-1 line-clamp-1">{props.location}</p>
              </div>
            </li>
            <li className="md:col-[2/3] md:row-[1/3] md:pl-5 md:bg-[linear-gradient(to_bottom,#333333_2px,transparent_2px)] md:bg-[length:2px_8px] md:bg-repeat-y md:bg-left-top">
              <div className="flex items-start">
                <span className="flex-shrink-0 flex items-center justify-center mr-2 rounded-full bg-gray-light aspect-square w-6">
                  <svg className="block aspect-square w-[14px] fill-primary">
                    <use xlinkHref="/symbol-defs.svg#icon-holiday"></use>
                  </svg>
                </span>
                <p className="flex-1 sp:line-clamp-1 md:line-clamp-2">
                  {props.holiday}
                </p>
              </div>
            </li>
          </ul>
        </div>
        <div className="py-5 text-center bg-gray-light">
          <div className="inline-block w-[240px] p-3 rounded-full border-2 border-white bg-primary-gradient text-white text-base leading-normal text-center font-bold shadow-[4px_4px_0_0_rgba(51,51,51,0.25)] group-hover:bg-primary-gradient-hover md:w-[256px]">
            <span className="flex items-center justify-center">
              <span>求人詳細を見る</span>
              <span className="flex-shrink-0 inline-block ml-2">
                <svg className="block w-4 h-4 fill-white">
                  <use xlinkHref="/symbol-defs.svg#icon-arrow-right"></use>
                </svg>
              </span>
            </span>
          </div>
        </div>
      </a>
    </article>
  );
};

export default ResultItem;
